module.exports = __webpack_public_path__ + "static/media/brian.9a3d4ceb.jpg";